import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'gd',
    fullName: 'Scottish Gaelic',
    nativeName: 'Gàidhlig',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Tha rudeigin iongantach a’ tighinn",
    landing_subtitle: "Tha ArgVoid na stiùidio leasachaidh app is geama. Cùm sùil, tha rudan ùra a’ tighinn a dh’ aithghearr!",
    select_language: "Tagh Cànan",
    search_placeholder: "Rannsaich cànanan...",
    terms_title: "Teirmean seirbheis",
    policy_title: "Poileasaidh Dìomhaireachd",
    cookies_title: "Poileasaidh Briosgaidean",
    terms_content: `
        <strong>1. Gabhail ri Teirmean</strong><br>
        Le bhith a’ faighinn cothrom air ArgVoid, thathas a’ gabhail ris na Cumhachan Seirbheis seo. Mura tèid gabhail ris na teirmean seo, cha bu chòir an t-seirbheis a chleachdadh.<br><br>

        <strong>2. Cleachdadh àrd-ùrlar</strong><br>
        Tha ArgVoid agus na tagraidhean aige air an toirt seachad “mar a tha” airson adhbharan fiosrachaidh agus cruthachail. Feumar an t-seirbheis a chleachdadh airson adhbharan laghail a-mhàin.<br><br>

        <strong>3. Giùlan toirmisgte</strong><br>
        Tha casg teann air a bhith a’ gabhail brath air so-leòntachd làraich, a’ spamadh, no a’ feuchainn ri faighinn gu bun-structair gun chead.<br><br>

        <strong>4. Àicheadh</strong><br>
        Faodar an àrd-ùrlar agus na seirbheisean atharrachadh aig àm sam bith gun rabhadh. Chan eil barantas sam bith air a thoirt seachad a thaobh ùrachadh no cothrom air an t-seirbheis.
    `,
    policy_content: `
        <strong>1. Cruinneachadh Fiosrachaidh</strong><br>
        Chan fheum an àrd-ùrlar dearbhadh neach-cleachdaidh no cruthachadh cunntas aig an àm seo. Chan eil fiosrachadh aithneachaidh pearsanta sam bith (leithid ainmean no seòlaidhean puist-d) air a chruinneachadh gu gnìomhach bho luchd-tadhail.<br><br>

        <strong>2. Dàta cleachdaidh</strong><br>
        Faodar mion-sgrùdaidhean bunaiteach gun urra a chruinneachadh gus trafaic làraich a thuigsinn agus na tagraidhean a leasachadh. Chan eil an dàta seo ceangailte ri dearbh-aithne neach-cleachdaidh fa leth.<br><br>

        <strong>3. Seirbheisean Treas-phàrtaidh</strong><br>
        Faodar solaraichean treas-phàrtaidh a chleachdadh airson seirbheisean aoigheachd agus anailis. Bidh cleachdaidhean prìobhaideachd nan solaraichean sin a’ riaghladh an dàta gun urra a thèid a phròiseasadh air a’ bhun-structair aca.<br><br>

        <strong>4. Tèarainteachd Dàta</strong><br>
        Tha ceumannan tèarainteachd reusanta air an cur an gnìomh gus an àrd-ùrlar a dhìon. Ach, chan eil dòigh tar-chuir sam bith thairis air an eadar-lìn gu tur tèarainte.<br><br>
    `,
    cookies_content: `
        <strong>1. Dè th' ann am briosgaidean agus stòradh ionadail?</strong><br>
        Tha briosgaidean agus stòradh ionadail brabhsair nam faidhlichean dàta beaga air an stòradh air an inneal gus cuimhne a chumail air roghainnean rèiteachaidh thar chuairtean.<br><br>

        <strong>2. Cleachd adhbhar</strong><br>
        Bithear a’ cleachdadh Browser LocalStorage gu teann gus roghainnean rèiteachaidh a shàbhaladh, leithid: <br>
        - Roghainnean cànain<br>
        - Rèiteachadh eadar-aghaidh cleachdaiche (me, cruth no suidheachadh cuspair) <br>
        - tasgadan tagraidh sealach<br><br>

        <strong>3. Gun tracadh</strong><br>
        Chan eilear a’ cleachdadh briosgaidean agus stòradh ionadail airson adhbharan sanasachd no tracadh treas-phàrtaidh. Tha a h-uile dàta air a stòradh dìreach airson prìomh ghnìomhachd an àrd-ùrlair.<br><br>

        <strong>4. smachd</strong><br>
        Faodar dàta brobhsair a ghlanadh aig àm sam bith tro roghainnean a’ bhrobhsair, a nì ath-shuidheachadh air rèiteachadh ionadail sam bith.
    `,
    cookie_consent_text: "Bidh sinn a’ cleachdadh briosgaidean bunaiteach gus dèanamh cinnteach gu bheil an làrach-lìn ag obair gu ceart, leithid do sheisean a chumail gnìomhach, do roghainn cànain a shàbhaladh, agus rèiteachadh gnàthaichte eile.",
    read_policy: "Leugh Poileasaidh Cookie",
    support_title: "Cuir fios gu neach-taic",
    support_subject_label: "Cuspair",
    support_message_label: "Teachdaireachd",
    support_submit_button: "Cuir Teachdaireachd",
    support_hint: "Nota: Fosglaidh seo an aplacaid post-d bunaiteach agad gus an teachdaireachd a chuir.",
    support_success_msg: "A' fosgladh an aplacaid puist-d agad...",
    support_error_msg: "Dh'fhàillig an teachdaireachd a chuir. Feuch ris a-rithist nas anmoiche.",
    explorer_title: "Explorer",
    history_title: "Eachdraidh",
    animation_title: "Beothachadh",
    config_title: "Rèiteachadh",
    tool_mouse: "Tagh (Ctrl+M)",
    tool_brush: "Brusg (Ctrl+B)",
    tool_brush_mode: "Modh Toggle (Soladach / Soilleir)",
    tool_eraser: "Sgrios-sgrios (Ctrl+E)",
    tool_brush_size: "Atharraich meud a’ bhruis",
    tool_bucket: "Lìonadh (Ctrl+F)",
    tool_eyedropper: "Sùilean",
    tool_grid: "Grid (Ctrl+Shift+B)",
    tool_rotate: "Rothaich (Ctrl+Shift+R)",
    tool_flip_h: "Dèan flip H (Ctrl+Shift+H)",
    tool_flip_v: "Dèan flip air V (Ctrl+Shift+V)",
    tool_transpose: "Transpose (Ctrl+Shift+T)",
    label_width: "Leud",
    label_height: "Àirde",
    label_frames: "Àireamh de fhrèamaichean",
    label_animation: "Stoidhle Beothachaidh",
    label_background_color: "Dath cùl-fhiosrachaidh",
    label_interval: "Eadar-ama",
    tool_anim_config: "Rèiteachadh Beothachaidh",
    label_new_width: "Leud Ùr",
    label_new_height: "Àirde Ùr",
    label_apply: "Cuir a-steach",
    label_colors: "Dathan",
    label_size: "Meud",
    label_tolerance: "Fulangas",
    val_horizontal: "Cothromach",
    val_vertical: "Inghearach",
    val_sequence: "Seicheamh",
    val_bounce: "Breab",
    val_random: "Air thuaiream",
    val_solid: "Soladach",
    val_clear: "Soilleir",
    action_add_sheet: "Duilleag Ùr",
    action_import: "Import",
    action_export: "Às-mhalairt",
    action_sort_projects: "Deasaich",
    sort_date_old: "As sine an toiseach",
    sort_date_new: "As ùire an toiseach",
    sort_name_az: "Ainm (AZ)",
    sort_name_za: "Ainm (Z-A)",
    action_new_sprite: "Spiorad ùr",
    action_new_project: "Pròiseact Ùr",
    modal_save_all_title: "Sàbhail a h-uile atharrachadh",
    modal_save_all_desc: "Tagh am maoin airson a shàbhaladh:",
    modal_save_selected: "Sàbhail Taghte",
    action_saved: "Air a shàbhaladh",
    modal_create_sprite_title: "Cruthaich Sprite Ùr",
    modal_create_project_title: "Cruthaich Pròiseact Ùr",
    modal_add_sheet_title: "Cuir duilleag ùr ris",
    modal_rename_sheet_title: "Ath-ainmich an duilleag",
    modal_rename_sprite_title: "Thoir ainm ùr air Sprite",
    modal_delete_sprite_title: "Sguab às Sprite",
    modal_delete_project_title: "Sguab às Pròiseact",
    modal_delete_sheet_title: "Sguab às Duilleag",
    placeholder_sprite_name: "Ainm",
    placeholder_project_name: "Ainm",
    placeholder_sheet_name: "Ainm",
    placeholder_new_name: "Ainm Ùr",
    action_create: "Cruthaich",
    action_add: "Cuir ris",
    action_rename: "Ath-ainmich",
    action_duplicate: "Dùblachadh",
    action_delete: "Sguab às",
    action_cancel: "Sguir dheth",
    confirm_delete_sprite: "A bheil thu cinnteach gu bheil thu airson an sprite seo a sguabadh às?",
    confirm_delete_project: "A bheil thu cinnteach gu bheil thu airson am pròiseact seo a sguabadh às? Thèid a h-uile sprites a thoirt air falbh.",
    confirm_delete_sheet: "A bheil thu cinnteach gu bheil thu airson an duilleag seo a sguabadh às?",
    err_select_sprite: "Feuch an tagh thu sprite an toiseach.",
    err_select_project: "Feuch an tagh thu pròiseact an toiseach.",
    err_name_empty: "Chan fhaod an t-ainm a bhith falamh.",
    err_sprite_exists: "Tha sprite leis an ainm sin ann mu thràth.",
    err_project_exists: "Tha pròiseact leis an ainm sin ann mu thràth.",
    err_no_content: "Chan eil susbaint ri shàbhaladh.",
    err_no_changes: "Chan eil atharrachaidhean ri shàbhaladh.",
    err_delete_last_sheet: "Cha ghabh an duilleag mu dheireadh a sguabadh às.",
    err_extract_frames: "Cha b' urrainn dhuinn frèamaichean sam bith a thoirt a-mach.",
    err_indexeddb: "Dh'fhàillig an sàbhaladh gu h-ionadail. Is dòcha nach cuir do bhrobhsair taic ri IndexedDB.",
    msg_upload_success: "Shoirbhich le luchdachadh suas: {0}",
    msg_upload_failed: "Dh'fhàillig an luchdadh suas: {0}",
    msg_save_success: "Sàbhail soirbheachail.",
    msg_saving: "A' sàbhaladh...",
    msg_multi_save_result: "Sàbhaladh {0} so-mhaoin. {1} fàilligidhean.",
    menu_title: "Clàr-taice",
    menu_save: "Sàbhail",
    menu_save_all: "Sàbhail na h-uile",
    menu_support: "Cuir fios gu neach-taic",
    label_local_storage: "Stòradh Ionadail",
    label_sign_in: "Soidhnig a-steach",
    modal_export_title: "Às-mhalairt Sprite",
    label_filename: "Ainm faidhle",
    label_format: "Cruth",
    action_export_confirm: "Às-mhalairt",
};

export default translations;
